import { COMPANY } from '../actions';

const initialState = {
  isFetching: false,
  select: { id: '', companyName: '' },
  data: [],
  isError: false,
  dataError: null
};

export default (state = initialState, { type, payload, error }) => {
  switch (type) {
    case COMPANY.GET_COMPANY_PENDING:
      return {
        isFetching: true,
        select: { id: '', companyName: '' },
        data: [],
        isError: false,
        dataError: null
      };

    case COMPANY.GET_COMPANY_SUCCESS:
      return { ...state, isFetching: false, select: payload[0], data: payload };

    case COMPANY.GET_COMPANY_FALIED:
      return {
        isFetching: false,
        select: { id: '', companyName: '' },
        data: [],
        isError: true,
        dataError: error
      };

    case COMPANY.SET_COMPANY_SELECT:
      return {
        ...state,
        select: payload
      };

    default:
      return state;
  }
};
